import { ArrowRight } from "lucide-react";
import { Link } from "wouter";
import { PageMeta } from "@/components/PageMeta";
import { BLOG, BEEF_LOC_LAC_ARTICLE } from "@/lib/blog";
import { DESSERTS_ARTICLE } from "@/lib/dessertsArticle";
import { FAMILY_RECIPES_ARTICLE } from "@/lib/familyRecipesArticle";
import { KAMPOT_PEPPER_ARTICLE } from "@/lib/kampotPepperArticle";
import { VEGETARIAN_ARTICLE } from "@/lib/vegetarianArticle";
import { CHRISTMAS_PARTY_ARTICLE } from "@/lib/christmasPartyArticle";
import { AMOK_HOME_ARTICLE } from "@/lib/amokAtHomeArticle";

export default function BlogPage() {
  const article = BEEF_LOC_LAC_ARTICLE;
  return (
    <div className="blog-index">
      <PageMeta title={BLOG.title} description={BLOG.description} path={BLOG.path} image={`https://www.angkorflavours.com.au${article.image}`} />
      <section className="intent-hero">
        <div className="container blog-index-heading">
          <p className="eyebrow">ANGKOR Cambodian Flavours</p>
          <h1>Blog</h1>
          <p>Stories, dish guides and Cambodian food culture from ANGKOR, a Cambodian restaurant at 389 Spencer St, West Melbourne.</p>
        </div>
      </section>
      <section className="section parchment-section">
        <div className="container blog-card-grid">
          <article className="blog-card">
            <Link href={AMOK_HOME_ARTICLE.path} className="blog-card-image" aria-label={`Read ${AMOK_HOME_ARTICLE.headline}`}>
              <img src={AMOK_HOME_ARTICLE.image} alt={AMOK_HOME_ARTICLE.imageAlt} width="640" height="800" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={AMOK_HOME_ARTICLE.datePublished}>{AMOK_HOME_ARTICLE.dateLabel}</time>
              <h2><Link href={AMOK_HOME_ARTICLE.path}>{AMOK_HOME_ARTICLE.headline}</Link></h2>
              <p>{AMOK_HOME_ARTICLE.excerpt}</p>
              <Link href={AMOK_HOME_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={CHRISTMAS_PARTY_ARTICLE.path} className="blog-card-image" aria-label={`Read ${CHRISTMAS_PARTY_ARTICLE.headline}`}>
              <img src={CHRISTMAS_PARTY_ARTICLE.image} alt={CHRISTMAS_PARTY_ARTICLE.imageAlt} width="1800" height="1012" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={CHRISTMAS_PARTY_ARTICLE.datePublished}>{CHRISTMAS_PARTY_ARTICLE.dateLabel}</time>
              <h2><Link href={CHRISTMAS_PARTY_ARTICLE.path}>{CHRISTMAS_PARTY_ARTICLE.headline}</Link></h2>
              <p>{CHRISTMAS_PARTY_ARTICLE.excerpt}</p>
              <Link href={CHRISTMAS_PARTY_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={VEGETARIAN_ARTICLE.path} className="blog-card-image" aria-label={`Read ${VEGETARIAN_ARTICLE.headline}`}>
              <img src={VEGETARIAN_ARTICLE.image} alt={VEGETARIAN_ARTICLE.imageAlt} width="1600" height="2000" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={VEGETARIAN_ARTICLE.datePublished}>{VEGETARIAN_ARTICLE.dateLabel}</time>
              <h2><Link href={VEGETARIAN_ARTICLE.path}>{VEGETARIAN_ARTICLE.headline}</Link></h2>
              <p>{VEGETARIAN_ARTICLE.excerpt}</p>
              <Link href={VEGETARIAN_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={KAMPOT_PEPPER_ARTICLE.path} className="blog-card-image" aria-label={`Read ${KAMPOT_PEPPER_ARTICLE.headline}`}>
              <img src={KAMPOT_PEPPER_ARTICLE.image} alt={KAMPOT_PEPPER_ARTICLE.imageAlt} width="1600" height="1200" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={KAMPOT_PEPPER_ARTICLE.datePublished}>{KAMPOT_PEPPER_ARTICLE.dateLabel}</time>
              <h2><Link href={KAMPOT_PEPPER_ARTICLE.path}>{KAMPOT_PEPPER_ARTICLE.headline}</Link></h2>
              <p>{KAMPOT_PEPPER_ARTICLE.excerpt}</p>
              <Link href={KAMPOT_PEPPER_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={FAMILY_RECIPES_ARTICLE.path} className="blog-card-image" aria-label={`Read ${FAMILY_RECIPES_ARTICLE.headline}`}>
              <img src={FAMILY_RECIPES_ARTICLE.image} srcSet={FAMILY_RECIPES_ARTICLE.imageSrcSet} sizes="(max-width: 767px) calc(100vw - 32px), 50vw" alt={FAMILY_RECIPES_ARTICLE.imageAlt} width="1600" height="2000" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={FAMILY_RECIPES_ARTICLE.datePublished}>{FAMILY_RECIPES_ARTICLE.dateLabel}</time>
              <h2><Link href={FAMILY_RECIPES_ARTICLE.path}>{FAMILY_RECIPES_ARTICLE.headline}</Link></h2>
              <p>{FAMILY_RECIPES_ARTICLE.excerpt}</p>
              <Link href={FAMILY_RECIPES_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={DESSERTS_ARTICLE.path} className="blog-card-image" aria-label={`Read ${DESSERTS_ARTICLE.headline}`}>
              <img src={DESSERTS_ARTICLE.image} srcSet={DESSERTS_ARTICLE.imageSrcSet} sizes="(max-width: 767px) calc(100vw - 32px), 50vw" alt={DESSERTS_ARTICLE.imageAlt} width="1440" height="1920" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={DESSERTS_ARTICLE.datePublished}>{DESSERTS_ARTICLE.dateLabel}</time>
              <h2><Link href={DESSERTS_ARTICLE.path}>{DESSERTS_ARTICLE.headline}</Link></h2>
              <p>{DESSERTS_ARTICLE.excerpt}</p>
              <Link href={DESSERTS_ARTICLE.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
          <article className="blog-card">
            <Link href={article.path} className="blog-card-image" aria-label={`Read ${article.headline}`}>
              <img src={article.image} alt={article.imageAlt} width="1600" height="1200" loading="eager" />
            </Link>
            <div className="blog-card-copy">
              <time dateTime={article.datePublished}>{article.dateLabel}</time>
              <h2><Link href={article.path}>{article.headline}</Link></h2>
              <p>{article.excerpt}</p>
              <Link href={article.path} className="text-link blog-read-link">Read article <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}
